// extracted by mini-css-extract-plugin
export default {"panelListWrapper":"panel_panelListWrapper__Ri0KM","panelWrapper":"panel_panelWrapper__CvsMo","panel":"panel_panel__MMQkw","panelLogoWrapper":"panel_panelLogoWrapper__MmnUj"};